import { createFeatureSelector, createSelector, State } from '@ngrx/store';
import { CalculationState } from '../../shared/models/calculation-state';

export const selectCalculationFeature = createFeatureSelector<CalculationState>('calculation');

export const selectCalculation = createSelector(selectCalculationFeature, (state) => state.calculation);

export const selectLoading = createSelector(selectCalculationFeature, (state) => state.loading);

export const selectError = createSelector(selectCalculationFeature, (state) => state.error);

export const selectName = createSelector(selectCalculation, (state) => state?.name);

export const isEditable = createSelector(selectCalculation, (state) => state?.editMode === 'edit');

export const selectTitle = createSelector(selectCalculation, (state) => {
  if (!state?.name) {
    return null;
  }

  const isEditMode = state.editMode?.toLowerCase() === 'edit';
  const readOnlySuffix = isEditMode ? '' : ' (Read Only)';

  return `${state.name} - ${state.versionName}${readOnlySuffix}`;
});

export const selectMode = createSelector(selectCalculation, (state) => state?.editMode);

export const selectPortionTotals = createSelector(selectCalculation, (state) => state?.portionTotals ?? []);

export const selectAggregateTotals = createSelector(selectCalculation, (state) => state?.aggregateTotals ?? null);
